/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommerceDeliveryDefaults
 */
export interface BigCommerceDeliveryDefaults {
  /**
   *
   * @type {string}
   * @memberof BigCommerceDeliveryDefaults
   */
  locationType: string;
  /**
   *
   * @type {Array<string>}
   * @memberof BigCommerceDeliveryDefaults
   */
  accessorials: Array<string>;
  /**
   *
   * @type {string}
   * @memberof BigCommerceDeliveryDefaults
   */
  distributionWarehouseBrand?: string | null;
}

/**
 * Check if a given object implements the BigCommerceDeliveryDefaults interface.
 */
export function instanceOfBigCommerceDeliveryDefaults(
  value: object,
): value is BigCommerceDeliveryDefaults {
  if (!("locationType" in value) || value["locationType"] === undefined)
    return false;
  if (!("accessorials" in value) || value["accessorials"] === undefined)
    return false;
  return true;
}

export function BigCommerceDeliveryDefaultsFromJSON(
  json: any,
): BigCommerceDeliveryDefaults {
  return BigCommerceDeliveryDefaultsFromJSONTyped(json, false);
}

export function BigCommerceDeliveryDefaultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceDeliveryDefaults {
  if (json == null) {
    return json;
  }
  return {
    locationType: json["locationType"],
    accessorials: json["accessorials"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
  };
}

export function BigCommerceDeliveryDefaultsToJSON(
  json: any,
): BigCommerceDeliveryDefaults {
  return BigCommerceDeliveryDefaultsToJSONTyped(json, false);
}

export function BigCommerceDeliveryDefaultsToJSONTyped(
  value?: BigCommerceDeliveryDefaults | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locationType: value["locationType"],
    accessorials: value["accessorials"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
  };
}
